const overlap = () => {
  const sections = document.querySelectorAll(".section");

  for (const [index, section] of sections.entries()) {
    if (section.classList.contains("t-overlap")) {
      const lastSection = sections[index - 1];
      const lastSectionBackground = lastSection
        .computedStyleMap()
        .get("background-color")
        .toString();

      const firstParagraph = section.querySelector("[class^=paragraph]");
      console.log(firstParagraph);
      const overlap = document.createElement("div");
      overlap.classList.add("overlap");
      overlap.style.backgroundColor = lastSectionBackground;
      firstParagraph.prepend(overlap);
    }
  }
};

export default overlap;
